/**
 * Component that displays the current application version
 * Reads version from package.json and shows development mode indicator
 */
import { JSX } from 'react';
import pkg from '../../../package.json';

// Define the type for the package.json data we need
interface PackageJson {
  version: string;
  name: string;
}

export function VersionInfo(): JSX.Element {
  // Cast the imported package to our interface
  const { version } = pkg as PackageJson;

  // Check if we're in development mode
  const isDev = import.meta.env.DEV === true;

  return (
    <div className="text-xs text-gray-500 mt-4">
      Version: {version}
      {isDev && " (Development)"}
    </div>
  );
}
